export const indexStateData = {
    loading: false,
    error:false,
    success:false,
    message:"",
    accessToken:null
  };